<template>
  <a-date-picker
    v-bind="attrs"
    :class="[bem.b(), bem.is(isGray ? 'gray-date-picker' : '')]"
  >
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </a-date-picker>
</template>

<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'

import { useAttrs } from 'vue'
import { datePickerProps } from './date-picker'

defineOptions({ name: 'LlDatePicker' })

const attrs = useAttrs()
const bem = createNamespace('date-picker')

defineProps(datePickerProps)
</script>
